const COLOR_COMBINATIONS = [
  { backgroundColor: "#E2F9EA", textColor: "#065F46" }, // Light green bg, dark green text
  { backgroundColor: "#EDE9FE", textColor: "#5B21B6" }, // Light indigo bg, dark indigo text
  { backgroundColor: "#FEE2E2", textColor: "#991B1B" }, // Light red bg, dark red text
  { backgroundColor: "#FED7AA", textColor: "#7C2D12" }, // Light orange bg, dark orange text
  { backgroundColor: "#F3E8FF", textColor: "#6B21A8" }, // Light violet bg, dark violet text
  { backgroundColor: "#DBEAFE", textColor: "#1E3A8A" }, // Light blue bg, dark blue text
  { backgroundColor: "#FCE7F3", textColor: "#BE185D" }, // Light pink bg, dark pink text
  { backgroundColor: "#ECFDF5", textColor: "#166534" }, // Light emerald bg, dark emerald text
  { backgroundColor: "#FEF3C7", textColor: "#92400E" }, // Light yellow bg, dark yellow text
  { backgroundColor: "#E0F2FE", textColor: "#0C4A6E" }, // Light sky bg, dark sky text
  { backgroundColor: "#F3E8FF", textColor: "#581C87" }, // Light purple bg, dark purple text
  { backgroundColor: "#FDF2F8", textColor: "#9D174D" }, // Light rose bg, dark rose text
  { backgroundColor: "#F0FDF4", textColor: "#14532D" }, // Light lime bg, dark lime text
  { backgroundColor: "#FFFBEB", textColor: "#78350F" }, // Light amber bg, dark amber text
  { backgroundColor: "#F0F9FF", textColor: "#0369A1" }, // Light cyan bg, dark cyan text
];

/**
 * Get color combination based on the first letter of a name
 * @param {string} name - The name to generate colors for
 * @returns {Object} - Object containing backgroundColor and textColor
 */
export const getAvatarColors = (name: string) => {
  if (!name || typeof name !== "string") {
    return COLOR_COMBINATIONS[0];
  }
  const firstLetter = name.charAt(0).toUpperCase();
  const letterIndex = firstLetter.charCodeAt(0) - 65; // 65 is 'A' in ASCII
  const index =
    letterIndex >= 0 && letterIndex < 26
      ? letterIndex % COLOR_COMBINATIONS.length
      : firstLetter.charCodeAt(0) % COLOR_COMBINATIONS.length;

  return COLOR_COMBINATIONS[index];
};

/**
 * Get initials from a full name (single character)
 * @param {string} name - The full name
 * @returns {string} - The first letter of the name
 */
export const getInitials = (name: string) => {
  if (!name || typeof name !== "string") {
    return "?";
  }

  const trimmedName = name?.trim()?.split(" ")[0];

  if (trimmedName.length === 0) {
    return "?";
  }

  return trimmedName.charAt(0).toUpperCase();
};
